import React, { FC, useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import {
  callApi,
  IChannel,
  ISelection,
  shouldShowSubTab,
  SubHeaderTabs,
} from "./helper";
import { distributionChannelsUrl } from "../../../api/endpoints";
import { TabPanel } from "./tabPanel";
import { TabHeader } from "./tabHeader";
import { IVideo } from "../../admin/videos/hooks/useFetchVideos";
import { MediaTabView } from "./mediaTabView";
import { MediaCarousalDetails } from "./mediaCarousalDetails";
import { MediaIndividualDetails } from "./mediaIndividualDetails";

interface Props {
  group: any;
  files: Array<IVideo>;
  selections: Array<ISelection>;
  setSelections: (data: Array<any>) => void;
}

export const DistributionBody: FC<Props> = (props) => {
  const { files } = props;
  const [channels, setChannels] = useState<Array<IChannel>>([]);
  const [tabValue, setTabValue] = useState(0);
  const [subTabValue, setSubTabValue] = useState(0);

  useEffect(() => {
    callApi(distributionChannelsUrl).then((data) => {
      if (data) setChannels(data.rows);
    });
  }, []);

  const isLinkMode = useMemo(
    () => shouldShowSubTab(channels, tabValue),
    [channels, tabValue]
  );

  return (
    <Box className="mt-2">
      <TabHeader
        value={tabValue}
        handleChange={setTabValue}
        options={channels.map((e) => e.name)}
      />
      {channels.map((channel, index: any) => {
        const mediaProps = { ...props, channel };
        return (
          <TabPanel value={tabValue} index={index} key={`channels-${index}`}>
            {isLinkMode ? (
              <>
                <TabHeader
                  value={subTabValue}
                  handleChange={setSubTabValue}
                  customClassName="mt-8 mb-3"
                  options={SubHeaderTabs(files?.length)}
                />
                <TabPanel index={0} value={subTabValue}>
                  <MediaCarousalDetails {...mediaProps} />
                </TabPanel>
                <TabPanel index={1} value={subTabValue}>
                  <MediaIndividualDetails {...mediaProps} />
                </TabPanel>
              </>
            ) : (
              <MediaTabView {...mediaProps} />
            )}
          </TabPanel>
        );
      })}
    </Box>
  );
};
